var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Cookies from 'js-cookie';
import { bulkAddToCart, resetCart } from '../services/storefront/cart';
import { get, post } from './request';
import { getCookieDomain } from './util';
import { loop_returns } from './config';
export var LOOP_ONSTORE_COOKIE = 'BOM-LOOP_ONSTORE';
var LOOP_ONSTORE_CART_COOKIE = 'BOM-LOOP_ONSTORE_CART';
var hydrateShopifyCart = function (loopParams, apolloClient) { return __awaiter(void 0, void 0, void 0, function () {
    var rawLoopCart, loopCart, loopCartContents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                rawLoopCart = Cookies.get(LOOP_ONSTORE_CART_COOKIE);
                loopCart = rawLoopCart ? JSON.parse(rawLoopCart) : null;
                if (!((loopCart === null || loopCart === void 0 ? void 0 : loopCart.token) && loopParams.loop_return_id === loopCart.returnId)) return [3 /*break*/, 3];
                return [4 /*yield*/, get("https://api.loopreturns.com/api/v1/cart/".concat(loopCart.token), {
                        is3rdParty: true,
                        headers: { 'X-Authorization': loop_returns.API_KEY }
                    })];
            case 1:
                loopCartContents = _a.sent();
                return [4 /*yield*/, bulkAddToCart.apply(void 0, __spreadArray([apolloClient], loopCartContents.cart, false))];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                if (loopCart === null || loopCart === void 0 ? void 0 : loopCart.token) {
                    // Remove old Loop cart cookie
                    Cookies.remove(LOOP_ONSTORE_CART_COOKIE, { domain: getCookieDomain() });
                }
                _a.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Check for Loop Returns parameters to begin the "On Store" experience and persist them.
 * SIDE EFFECTS: Deletes any existing cart and replaces it with contents from Loop cart.
 */
export var initializeLoopOnStore = function (apolloClient) { return __awaiter(void 0, void 0, void 0, function () {
    var params, loopParams;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!window.location.search.includes('loop_total')) {
                    return [2 /*return*/];
                }
                params = new URLSearchParams(window.location.search);
                loopParams = Array.from(params)
                    .filter(function (_a) {
                    var key = _a[0];
                    return key.startsWith('loop');
                })
                    .reduce(function (acc, _a) {
                    var _b;
                    var key = _a[0], value = _a[1];
                    return (__assign(__assign({}, acc), (_b = {}, _b[key] = value, _b)));
                }, {});
                Object.keys(loopParams).forEach(function (key) { return params.delete(key); });
                // Persist Loop parameters in cookie for use on headless & non-headless pages.
                Cookies.set(LOOP_ONSTORE_COOKIE, JSON.stringify(loopParams), {
                    domain: getCookieDomain()
                });
                // Delete existing cart per Loop recommendation.
                resetCart();
                // Remove processed params from URL
                window.history.replaceState({}, '', "".concat(window.location.origin).concat(window.location.pathname, "?").concat(params));
                return [4 /*yield*/, hydrateShopifyCart(loopParams, apolloClient)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
/**
 * Determines if a Loop On-Store experience has been initialized.
 */
export var isLoopOnStore = function () {
    return Boolean(Cookies.get(LOOP_ONSTORE_COOKIE));
};
/**
 * Fetches and parses BOM-LOOP_ONSTORE cookie object value
 * @returns BOM-LOOP_ONSTORE cookie parsed object value
 */
export var getLoopParams = function () {
    var rawLoopParams = Cookies.get(LOOP_ONSTORE_COOKIE);
    if (!rawLoopParams) {
        return;
    }
    var loopParams = JSON.parse(rawLoopParams);
    return loopParams;
};
export var beginLoopCheckout = function (variantIds) { return __awaiter(void 0, void 0, void 0, function () {
    var loopParams, rawLoopCart, loopCart;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                loopParams = getLoopParams();
                if (!loopParams) {
                    (_a = window.DD_RUM) === null || _a === void 0 ? void 0 : _a.addError(new Error('Attempted to create on-store experience but no Loop parameters were found.'), { location: 'integration/loop-returns' });
                    return [2 /*return*/];
                }
                rawLoopCart = Cookies.get(LOOP_ONSTORE_CART_COOKIE);
                loopCart = rawLoopCart ? JSON.parse(rawLoopCart) : null;
                if (!(loopParams.loop_return_id === (loopCart === null || loopCart === void 0 ? void 0 : loopCart.returnId))) return [3 /*break*/, 2];
                return [4 /*yield*/, post("https://api.loopreturns.com/api/v1/cart/".concat(loopCart.token), { cart: variantIds }, { is3rdParty: true, headers: { 'X-Authorization': loop_returns.API_KEY } })];
            case 1:
                _b.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, post('https://api.loopreturns.com/api/v1/cart', { cart: variantIds }, { is3rdParty: true, headers: { 'X-Authorization': loop_returns.API_KEY } }).then(function (r) {
                    return ({
                        token: r.token,
                        returnId: loopParams.loop_return_id
                    });
                })];
            case 3:
                loopCart = _b.sent();
                _b.label = 4;
            case 4:
                Cookies.set(LOOP_ONSTORE_CART_COOKIE, JSON.stringify(loopCart), {
                    domain: getCookieDomain()
                });
                // Remove params & cart
                Cookies.remove(LOOP_ONSTORE_COOKIE, { domain: getCookieDomain() });
                resetCart(true);
                window.location = "https://".concat(loopParams.loop_domain, "/#/cart/v2/").concat(loopCart.token);
                return [2 /*return*/];
        }
    });
}); };
export default {};
